export default __webpack_public_path__ + "static/media/contact.eef1f173.png";